import { useQuery } from '@tanstack/react-query'
import { BookingCar } from '~/shared/api'
import { Option } from '~/shared/config/constants'

export const useDependentBrandModelOptions = ({
  regionCode,
  locationIds,
  selectedBrands,
  taxiparkId,
}: {
  regionCode?: string
  locationIds?: string[]
  selectedBrands?: Option[]
  taxiparkId?: UniqueId
}) => {
  const { isFetching, data = {} } = useQuery(
    ['brand-model', regionCode, locationIds],
    () => BookingCar.getModels({ regionCode, locationIds, taxiparkId }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      retry: false,
    },
  )

  const brandOptions = Object.entries(data).map(([brand]) => ({
    id: brand,
    label: brand,
  }))

  const filteredModels = selectedBrands?.length
    ? selectedBrands.reduce<[string, string[]][]>((acc, { id }) => {
        if (data[id]) {
          acc.push([id, data[id]])
        }
        return acc
      }, [])
    : Object.entries(data)

  const modelOptions = filteredModels.reduce(
    (acc: Option[], [brand, models]) => {
      const modelsArray = Array.isArray(models) ? models : []

      return [
        ...acc,
        ...modelsArray.map((model) => ({
          id: model,
          label: model,
          groupedByKey: brand,
        })),
      ]
    },
    [],
  )

  return {
    isFetchingDependentBrandOptions: isFetching,
    brandOptions,
    modelOptions,
  }
}
